import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AppointPreparation =
  | 'done'
  | 'pending'
  | 'progress';

export type Appointment = {
  __typename?: 'Appointment';
  address_ward?: Maybe<Scalars['String']>;
  annual_income?: Maybe<Scalars['Int']>;
  appointment_count?: Maybe<Scalars['Int']>;
  appointment_date?: Maybe<Scalars['String']>;
  appointment_family_number?: Maybe<Scalars['String']>;
  appointment_result?: Maybe<AppointmentResult>;
  appointment_result_reason?: Maybe<Scalars['String']>;
  appointment_status?: Maybe<AppointmentStatus>;
  birth_date?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Int']>;
  customer_id?: Maybe<Scalars['String']>;
  family_name?: Maybe<Scalars['String']>;
  family_name_kana?: Maybe<Scalars['String']>;
  floor_plan?: Maybe<FloorPlan>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars['String']>;
  inquiry_price?: Maybe<Scalars['Int']>;
  line_resistration?: Maybe<Scalars['Boolean']>;
  media?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
  monthly_repayment_amount?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  name_kana?: Maybe<Scalars['String']>;
  neck?: Maybe<Scalars['String']>;
  negotiation_person?: Maybe<Scalars['String']>;
  own_resources?: Maybe<Scalars['String']>;
  preparation?: Maybe<AppointPreparation>;
  preparation_check?: Maybe<Scalars['Boolean']>;
  rank?: Maybe<AppointmentRank>;
  remarks?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Int']>;
};

export type AppointmentInput = {
  address_ward?: InputMaybe<Scalars['String']>;
  annual_income?: InputMaybe<Scalars['Int']>;
  appointment_count?: InputMaybe<Scalars['Int']>;
  appointment_date?: InputMaybe<Scalars['String']>;
  appointment_family_number?: InputMaybe<Scalars['String']>;
  appointment_result?: InputMaybe<AppointmentResult>;
  appointment_result_reason?: InputMaybe<Scalars['String']>;
  appointment_status?: InputMaybe<AppointmentStatus>;
  birth_date?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['Int']>;
  customer_id: Scalars['String'];
  family_name?: InputMaybe<Scalars['String']>;
  family_name_kana?: InputMaybe<Scalars['String']>;
  floor_plan?: InputMaybe<FloorPlan>;
  gender?: InputMaybe<Gender>;
  inquiry_price?: InputMaybe<Scalars['Int']>;
  line_resistration?: InputMaybe<Scalars['Boolean']>;
  media?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  monthly_repayment_amount?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  name_kana?: InputMaybe<Scalars['String']>;
  neck?: InputMaybe<Scalars['String']>;
  negotiation_person?: InputMaybe<Scalars['String']>;
  own_resources?: InputMaybe<Scalars['String']>;
  preparation?: InputMaybe<AppointPreparation>;
  preparation_check?: InputMaybe<Scalars['Boolean']>;
  rank?: InputMaybe<AppointmentRank>;
  remarks?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['Int']>;
};

export type AppointmentRank =
  | 'a'
  | 'b'
  | 'c';

export type AppointmentResult =
  | 'next'
  | 'no'
  | 'yes';

export type AppointmentStatus =
  | 'after_apo_chasing'
  | 'application'
  | 'canceled_appointment'
  | 'contracted'
  | 'not_chasing'
  | 'refused_application'
  | 'unguided';

export type Child = {
  __typename?: 'Child';
  birth_date?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  school_area?: Maybe<Scalars['String']>;
  school_name?: Maybe<Scalars['String']>;
};

export type ChildInput = {
  birth_date?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  school_area?: InputMaybe<Scalars['String']>;
  school_name?: InputMaybe<Scalars['String']>;
};

export type CompromisePoint =
  | 'accident'
  | 'dirty'
  | 'highway'
  | 'north'
  | 'one_floor'
  | 'sunny'
  | 'view';

export type CompromisePointStates = {
  __typename?: 'CompromisePointStates';
  accident?: Maybe<Scalars['Boolean']>;
  dirty?: Maybe<Scalars['Boolean']>;
  highway?: Maybe<Scalars['Boolean']>;
  north?: Maybe<Scalars['Boolean']>;
  one_floor?: Maybe<Scalars['Boolean']>;
  sunny?: Maybe<Scalars['Boolean']>;
  view?: Maybe<Scalars['Boolean']>;
};

export type CompromisePointStatesInput = {
  accident?: InputMaybe<Scalars['Boolean']>;
  dirty?: InputMaybe<Scalars['Boolean']>;
  highway?: InputMaybe<Scalars['Boolean']>;
  north?: InputMaybe<Scalars['Boolean']>;
  one_floor?: InputMaybe<Scalars['Boolean']>;
  sunny?: InputMaybe<Scalars['Boolean']>;
  view?: InputMaybe<Scalars['Boolean']>;
};

export type Customer = {
  __typename?: 'Customer';
  acquisition_expected_date?: Maybe<Scalars['String']>;
  address_other?: Maybe<Scalars['String']>;
  address_ward?: Maybe<Scalars['String']>;
  appointment_status?: Maybe<AppointmentStatus>;
  bonus_payment?: Maybe<Scalars['Int']>;
  budget_max?: Maybe<Scalars['Int']>;
  children_info?: Maybe<Array<Maybe<Child>>>;
  compromise_point?: Maybe<CompromisePointStates>;
  consort_info?: Maybe<Parent>;
  created_at?: Maybe<Scalars['Int']>;
  customer_asset?: Maybe<Scalars['Int']>;
  customer_info?: Maybe<Parent>;
  debt?: Maybe<Scalars['Int']>;
  desired_area_and_station?: Maybe<Scalars['String']>;
  desired_floor_plan?: Maybe<FloorPlan>;
  details?: Maybe<Scalars['String']>;
  family_member_info?: Maybe<Array<Maybe<FamilyMember>>>;
  have_bicycle?: Maybe<Scalars['Boolean']>;
  have_disease?: Maybe<Scalars['Boolean']>;
  have_ev?: Maybe<Scalars['Boolean']>;
  have_permanent_residency?: Maybe<Scalars['Boolean']>;
  have_residence_rent_subsidy?: Maybe<Scalars['Boolean']>;
  have_vehicle?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  inquiries_to_other?: Maybe<Scalars['Boolean']>;
  inquiry_address_ward?: Maybe<Scalars['String']>;
  inquiry_date?: Maybe<Scalars['String']>;
  inquiry_property_floor_plan?: Maybe<FloorPlan>;
  inquiry_property_name?: Maybe<Scalars['String']>;
  inquiry_property_price?: Maybe<Scalars['Int']>;
  inquiry_property_width?: Maybe<Scalars['Int']>;
  insurance?: Maybe<Insurance>;
  internet_search_conditions?: Maybe<Scalars['String']>;
  is_get_married?: Maybe<Scalars['Boolean']>;
  line_resistration?: Maybe<Scalars['Boolean']>;
  media?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
  model_experience?: Maybe<Scalars['Int']>;
  monthly_payment?: Maybe<Scalars['Int']>;
  nationality?: Maybe<Scalars['String']>;
  nearest_station?: Maybe<Scalars['String']>;
  on_foot_minutes?: Maybe<Scalars['Int']>;
  other_asset?: Maybe<Scalars['Int']>;
  parent_asset?: Maybe<Scalars['Int']>;
  parking_fee?: Maybe<Scalars['Int']>;
  pet_breeding?: Maybe<Scalars['Boolean']>;
  plan_to_get_married?: Maybe<Scalars['Boolean']>;
  purchase_motive?: Maybe<Scalars['String']>;
  reaction?: Maybe<InquiryReaction>;
  residence_appearance?: Maybe<ResidenceAppearance>;
  residence_floor_plan?: Maybe<FloorPlan>;
  residence_rent?: Maybe<Scalars['Int']>;
  residence_rent_subsidy?: Maybe<Scalars['Int']>;
  residence_type?: Maybe<ResidenceType>;
  residence_type_other?: Maybe<Scalars['String']>;
  residence_update_date?: Maybe<Scalars['String']>;
  residence_width?: Maybe<Scalars['Int']>;
  residence_years?: Maybe<Scalars['Int']>;
  residents?: Maybe<Scalars['Int']>;
  stocks_and_bonds?: Maybe<Scalars['Int']>;
  total_customer_assets?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['Int']>;
  when_looking_for?: Maybe<Scalars['String']>;
  width_of_desire?: Maybe<Scalars['Int']>;
  width_of_min_desire?: Maybe<Scalars['Int']>;
  year_of_construction?: Maybe<Scalars['String']>;
};

export type CustomerHistory = {
  __typename?: 'CustomerHistory';
  created_at?: Maybe<Scalars['Int']>;
  customer_id?: Maybe<Scalars['String']>;
  history_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Int']>;
};

export type CustomerHistoryInput = {
  created_at?: InputMaybe<Scalars['Int']>;
  customer_id: Scalars['String'];
  history_date: Scalars['String'];
  memo: Scalars['String'];
};

export type CustomerIdMetaKeyInput = {
  customer_id: Scalars['String'];
  meta: Scalars['String'];
};

export type CustomerInput = {
  acquisition_expected_date?: InputMaybe<Scalars['String']>;
  address_other?: InputMaybe<Scalars['String']>;
  address_ward?: InputMaybe<Scalars['String']>;
  appointment_status?: InputMaybe<AppointmentStatus>;
  bonus_payment?: InputMaybe<Scalars['Int']>;
  budget_max?: InputMaybe<Scalars['Int']>;
  children_info?: InputMaybe<Array<InputMaybe<ChildInput>>>;
  compromise_point?: InputMaybe<CompromisePointStatesInput>;
  consort_info?: InputMaybe<ParentInput>;
  created_at?: InputMaybe<Scalars['Int']>;
  customer_asset?: InputMaybe<Scalars['Int']>;
  customer_info?: InputMaybe<ParentInput>;
  debt?: InputMaybe<Scalars['Int']>;
  desired_area_and_station?: InputMaybe<Scalars['String']>;
  desired_floor_plan?: InputMaybe<FloorPlan>;
  details?: InputMaybe<Scalars['String']>;
  family_member_info?: InputMaybe<Array<InputMaybe<FamilyMemberInput>>>;
  have_bicycle?: InputMaybe<Scalars['Boolean']>;
  have_disease?: InputMaybe<Scalars['Boolean']>;
  have_ev?: InputMaybe<Scalars['Boolean']>;
  have_permanent_residency?: InputMaybe<Scalars['Boolean']>;
  have_residence_rent_subsidy?: InputMaybe<Scalars['Boolean']>;
  have_vehicle?: InputMaybe<Scalars['Boolean']>;
  inquiries_to_other?: InputMaybe<Scalars['Boolean']>;
  inquiry_address_ward?: InputMaybe<Scalars['String']>;
  inquiry_date?: InputMaybe<Scalars['String']>;
  inquiry_property_floor_plan?: InputMaybe<FloorPlan>;
  inquiry_property_name?: InputMaybe<Scalars['String']>;
  inquiry_property_price?: InputMaybe<Scalars['Int']>;
  inquiry_property_width?: InputMaybe<Scalars['Int']>;
  insurance?: InputMaybe<Insurance>;
  internet_search_conditions?: InputMaybe<Scalars['String']>;
  is_get_married?: InputMaybe<Scalars['Boolean']>;
  line_resistration?: InputMaybe<Scalars['Boolean']>;
  media?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  model_experience?: InputMaybe<Scalars['Int']>;
  monthly_payment?: InputMaybe<Scalars['Int']>;
  nationality?: InputMaybe<Scalars['String']>;
  nearest_station?: InputMaybe<Scalars['String']>;
  on_foot_minutes?: InputMaybe<Scalars['Int']>;
  other_asset?: InputMaybe<Scalars['Int']>;
  parent_asset?: InputMaybe<Scalars['Int']>;
  parking_fee?: InputMaybe<Scalars['Int']>;
  pet_breeding?: InputMaybe<Scalars['Boolean']>;
  plan_to_get_married?: InputMaybe<Scalars['Boolean']>;
  purchase_motive?: InputMaybe<Scalars['String']>;
  reaction?: InputMaybe<InquiryReaction>;
  residence_appearance?: InputMaybe<ResidenceAppearance>;
  residence_floor_plan?: InputMaybe<FloorPlan>;
  residence_rent?: InputMaybe<Scalars['Int']>;
  residence_rent_subsidy?: InputMaybe<Scalars['Int']>;
  residence_type?: InputMaybe<ResidenceType>;
  residence_type_other?: InputMaybe<Scalars['String']>;
  residence_update_date?: InputMaybe<Scalars['String']>;
  residence_width?: InputMaybe<Scalars['Int']>;
  residence_years?: InputMaybe<Scalars['Int']>;
  residents?: InputMaybe<Scalars['Int']>;
  stocks_and_bonds?: InputMaybe<Scalars['Int']>;
  total_customer_assets?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['Int']>;
  when_looking_for?: InputMaybe<Scalars['String']>;
  width_of_desire?: InputMaybe<Scalars['Int']>;
  width_of_min_desire?: InputMaybe<Scalars['Int']>;
  year_of_construction?: InputMaybe<Scalars['String']>;
};

export type CustomerInputType =
  | 'appointment'
  | 'inquiry';

export type FamilyMember = {
  __typename?: 'FamilyMember';
  birth_date?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
};

export type FamilyMemberInput = {
  birth_date?: InputMaybe<Scalars['String']>;
  relationship?: InputMaybe<Scalars['String']>;
};

export type FloorPlan =
  | 'four_dk'
  | 'four_ldk'
  | 'one_dk'
  | 'one_k'
  | 'one_ldk'
  | 'one_r'
  | 'three_dk'
  | 'three_ldk'
  | 'two_dk'
  | 'two_k'
  | 'two_ldK';

export type Gender =
  | 'female'
  | 'male';

export type IdMetaNextToken = {
  __typename?: 'IdMetaNextToken';
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
};

export type IdMetaNextTokenInput = {
  id?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['String']>;
};

export type InquiryReaction =
  | 'action_required'
  | 'after_apo_chasing'
  | 'apo_chasing'
  | 'canceled'
  | 'contracted'
  | 'email_replied'
  | 'not_chasing'
  | 'nothing'
  | 'sms_replied'
  | 'talked';

export type Insurance =
  | 'nation'
  | 'social';

export type KeyInput = {
  id: Scalars['String'];
  meta: Scalars['String'];
};

export type ModelSearchAppointmentConnection = {
  __typename?: 'ModelSearchAppointmentConnection';
  appointments?: Maybe<Array<Maybe<Appointment>>>;
  next_token?: Maybe<IdMetaNextToken>;
};

export type ModelSearchCustomerConnection = {
  __typename?: 'ModelSearchCustomerConnection';
  customers?: Maybe<Array<Maybe<Customer>>>;
  next_token?: Maybe<IdMetaNextToken>;
};

export type ModelSortDirection =
  | 'ASC'
  | 'DESC';

export type Mutation = {
  __typename?: 'Mutation';
  createCustomerHistory: CustomerHistory;
  deleteAppointment: Appointment;
  deleteCustomer: Customer;
  deleteCustomerHistory: CustomerHistory;
  putAppointment: Appointment;
  putCustomer: Customer;
  updateCustomer: Customer;
  updateCustomerHistory: CustomerHistory;
};


export type MutationCreateCustomerHistoryArgs = {
  input: CustomerHistoryInput;
};


export type MutationDeleteAppointmentArgs = {
  key: KeyInput;
};


export type MutationDeleteCustomerArgs = {
  key: KeyInput;
};


export type MutationDeleteCustomerHistoryArgs = {
  key: KeyInput;
};


export type MutationPutAppointmentArgs = {
  input: AppointmentInput;
  key?: InputMaybe<KeyInput>;
};


export type MutationPutCustomerArgs = {
  input: CustomerInput;
  key?: InputMaybe<KeyInput>;
};


export type MutationUpdateCustomerArgs = {
  input: CustomerInput;
  key: KeyInput;
  type: CustomerInputType;
};


export type MutationUpdateCustomerHistoryArgs = {
  input: CustomerHistoryInput;
  key?: InputMaybe<KeyInput>;
};

export type Parent = {
  __typename?: 'Parent';
  annual_income?: Maybe<Scalars['Int']>;
  birth_date?: Maybe<Scalars['String']>;
  birthplace?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  family_name?: Maybe<Scalars['String']>;
  family_name_kana?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  industry_type?: Maybe<Scalars['String']>;
  length_of_service?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_kana?: Maybe<Scalars['String']>;
  nearest_station?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  work_style?: Maybe<WorkStyle>;
  workplace?: Maybe<Scalars['String']>;
};

export type ParentInput = {
  annual_income?: InputMaybe<Scalars['Int']>;
  birth_date?: InputMaybe<Scalars['String']>;
  birthplace?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  family_name?: InputMaybe<Scalars['String']>;
  family_name_kana?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  industry_type?: InputMaybe<Scalars['String']>;
  length_of_service?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_kana?: InputMaybe<Scalars['String']>;
  nearest_station?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  work_style?: InputMaybe<WorkStyle>;
  workplace?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  getCustomer: Customer;
  queryCustomerHistory?: Maybe<Array<Maybe<CustomerHistory>>>;
  searchAppointment?: Maybe<ModelSearchAppointmentConnection>;
  searchCustomer?: Maybe<ModelSearchCustomerConnection>;
};


export type QueryGetCustomerArgs = {
  key: KeyInput;
};


export type QueryQueryCustomerHistoryArgs = {
  key: CustomerIdMetaKeyInput;
};


export type QuerySearchAppointmentArgs = {
  conditions?: InputMaybe<SearchDurationCustomerIdConditionsInput>;
  options?: InputMaybe<SearchOptionsInput>;
};


export type QuerySearchCustomerArgs = {
  conditions?: InputMaybe<SearchDurationConditionsInput>;
  options?: InputMaybe<SearchOptionsInput>;
};

export type ResidenceAppearance =
  | 'new'
  | 'normal'
  | 'old';

export type ResidenceType =
  | 'apartmet'
  | 'company_house'
  | 'corp'
  | 'mansion'
  | 'other'
  | 'owned_house'
  | 'parents_home';

export type SearchDurationConditionsInput = {
  end_date?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['String']>;
};

export type SearchDurationCustomerIdConditionsInput = {
  customer_id?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['String']>;
};

export type SearchOptionsInput = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  direction?: InputMaybe<ModelSortDirection>;
  limit?: InputMaybe<Scalars['Int']>;
  next_token?: InputMaybe<IdMetaNextTokenInput>;
};

export type WorkStyle =
  | 'employee'
  | 'manager'
  | 'part'
  | 'self_employed';

export type GetCustomerQueryVariables = Exact<{
  key: KeyInput;
}>;


export type GetCustomerQuery = { __typename?: 'Query', getCustomer: { __typename?: 'Customer', id?: string | null, meta?: string | null, created_at?: number | null, updated_at?: number | null, inquiry_date?: string | null, inquiry_address_ward?: string | null, inquiry_property_name?: string | null, residents?: number | null, nationality?: string | null, have_permanent_residency?: boolean | null, acquisition_expected_date?: string | null, year_of_construction?: string | null, inquiry_property_price?: number | null, inquiry_property_width?: number | null, inquiry_property_floor_plan?: FloorPlan | null, media?: string | null, line_resistration?: boolean | null, memo?: string | null, reaction?: InquiryReaction | null, appointment_status?: AppointmentStatus | null, address_ward?: string | null, address_other?: string | null, nearest_station?: string | null, on_foot_minutes?: number | null, plan_to_get_married?: boolean | null, is_get_married?: boolean | null, pet_breeding?: boolean | null, have_vehicle?: boolean | null, have_bicycle?: boolean | null, parking_fee?: number | null, total_customer_assets?: number | null, customer_asset?: number | null, parent_asset?: number | null, stocks_and_bonds?: number | null, other_asset?: number | null, debt?: number | null, details?: string | null, insurance?: Insurance | null, have_disease?: boolean | null, residence_type?: ResidenceType | null, residence_type_other?: string | null, residence_appearance?: ResidenceAppearance | null, have_ev?: boolean | null, residence_width?: number | null, residence_floor_plan?: FloorPlan | null, residence_rent?: number | null, have_residence_rent_subsidy?: boolean | null, residence_rent_subsidy?: number | null, residence_years?: number | null, residence_update_date?: string | null, purchase_motive?: string | null, when_looking_for?: string | null, model_experience?: number | null, inquiries_to_other?: boolean | null, width_of_desire?: number | null, width_of_min_desire?: number | null, desired_floor_plan?: FloorPlan | null, monthly_payment?: number | null, bonus_payment?: number | null, budget_max?: number | null, internet_search_conditions?: string | null, desired_area_and_station?: string | null, customer_info?: { __typename?: 'Parent', family_name?: string | null, name?: string | null, family_name_kana?: string | null, name_kana?: string | null, gender?: Gender | null, birth_date?: string | null, phone_number?: string | null, email?: string | null, annual_income?: number | null, length_of_service?: number | null, work_style?: WorkStyle | null, workplace?: string | null, industry_type?: string | null, nearest_station?: string | null, birthplace?: string | null } | null, consort_info?: { __typename?: 'Parent', family_name?: string | null, name?: string | null, family_name_kana?: string | null, name_kana?: string | null, gender?: Gender | null, birth_date?: string | null, phone_number?: string | null, email?: string | null, annual_income?: number | null, length_of_service?: number | null, work_style?: WorkStyle | null, workplace?: string | null, industry_type?: string | null, nearest_station?: string | null, birthplace?: string | null } | null, children_info?: Array<{ __typename?: 'Child', birth_date?: string | null, gender?: Gender | null, school_name?: string | null, school_area?: string | null } | null> | null, family_member_info?: Array<{ __typename?: 'FamilyMember', relationship?: string | null, birth_date?: string | null } | null> | null, compromise_point?: { __typename?: 'CompromisePointStates', sunny?: boolean | null, view?: boolean | null, one_floor?: boolean | null, north?: boolean | null, highway?: boolean | null, dirty?: boolean | null, accident?: boolean | null } | null } };

export type SearchCustomerQueryVariables = Exact<{
  conditions?: InputMaybe<SearchDurationConditionsInput>;
  options?: InputMaybe<SearchOptionsInput>;
}>;


export type SearchCustomerQuery = { __typename?: 'Query', searchCustomer?: { __typename?: 'ModelSearchCustomerConnection', customers?: Array<{ __typename?: 'Customer', id?: string | null, meta?: string | null, created_at?: number | null, updated_at?: number | null, inquiry_date?: string | null, inquiry_address_ward?: string | null, inquiry_property_name?: string | null, residents?: number | null, nationality?: string | null, have_permanent_residency?: boolean | null, acquisition_expected_date?: string | null, year_of_construction?: string | null, inquiry_property_price?: number | null, inquiry_property_width?: number | null, inquiry_property_floor_plan?: FloorPlan | null, media?: string | null, line_resistration?: boolean | null, memo?: string | null, reaction?: InquiryReaction | null, appointment_status?: AppointmentStatus | null, address_ward?: string | null, address_other?: string | null, nearest_station?: string | null, on_foot_minutes?: number | null, plan_to_get_married?: boolean | null, is_get_married?: boolean | null, pet_breeding?: boolean | null, have_vehicle?: boolean | null, have_bicycle?: boolean | null, parking_fee?: number | null, total_customer_assets?: number | null, customer_asset?: number | null, parent_asset?: number | null, stocks_and_bonds?: number | null, other_asset?: number | null, debt?: number | null, details?: string | null, insurance?: Insurance | null, have_disease?: boolean | null, residence_type?: ResidenceType | null, residence_type_other?: string | null, residence_appearance?: ResidenceAppearance | null, have_ev?: boolean | null, residence_width?: number | null, residence_floor_plan?: FloorPlan | null, residence_rent?: number | null, have_residence_rent_subsidy?: boolean | null, residence_rent_subsidy?: number | null, residence_years?: number | null, residence_update_date?: string | null, purchase_motive?: string | null, when_looking_for?: string | null, model_experience?: number | null, inquiries_to_other?: boolean | null, width_of_desire?: number | null, width_of_min_desire?: number | null, desired_floor_plan?: FloorPlan | null, monthly_payment?: number | null, bonus_payment?: number | null, budget_max?: number | null, internet_search_conditions?: string | null, desired_area_and_station?: string | null, customer_info?: { __typename?: 'Parent', family_name?: string | null, name?: string | null, family_name_kana?: string | null, name_kana?: string | null, gender?: Gender | null, birth_date?: string | null, phone_number?: string | null, email?: string | null, annual_income?: number | null, length_of_service?: number | null, work_style?: WorkStyle | null, workplace?: string | null, industry_type?: string | null, nearest_station?: string | null, birthplace?: string | null } | null, consort_info?: { __typename?: 'Parent', family_name?: string | null, name?: string | null, family_name_kana?: string | null, name_kana?: string | null, gender?: Gender | null, birth_date?: string | null, phone_number?: string | null, email?: string | null, annual_income?: number | null, length_of_service?: number | null, work_style?: WorkStyle | null, workplace?: string | null, industry_type?: string | null, nearest_station?: string | null, birthplace?: string | null } | null, children_info?: Array<{ __typename?: 'Child', birth_date?: string | null, gender?: Gender | null, school_name?: string | null, school_area?: string | null } | null> | null, family_member_info?: Array<{ __typename?: 'FamilyMember', relationship?: string | null, birth_date?: string | null } | null> | null } | null> | null, next_token?: { __typename?: 'IdMetaNextToken', id?: string | null, meta?: string | null } | null } | null };

export type SearchAppointmentQueryVariables = Exact<{
  conditions?: InputMaybe<SearchDurationCustomerIdConditionsInput>;
  options?: InputMaybe<SearchOptionsInput>;
}>;


export type SearchAppointmentQuery = { __typename?: 'Query', searchAppointment?: { __typename?: 'ModelSearchAppointmentConnection', appointments?: Array<{ __typename?: 'Appointment', id?: string | null, meta?: string | null, customer_id?: string | null, created_at?: number | null, updated_at?: number | null, appointment_status?: AppointmentStatus | null, appointment_date?: string | null, rank?: AppointmentRank | null, appointment_family_number?: string | null, inquiry_price?: number | null, floor_plan?: FloorPlan | null, monthly_repayment_amount?: string | null, annual_income?: number | null, own_resources?: string | null, appointment_count?: number | null, media?: string | null, negotiation_person?: string | null, memo?: string | null, remarks?: string | null, neck?: string | null, preparation?: AppointPreparation | null, preparation_check?: boolean | null, appointment_result?: AppointmentResult | null, appointment_result_reason?: string | null, family_name?: string | null, name?: string | null, family_name_kana?: string | null, name_kana?: string | null, line_resistration?: boolean | null, birth_date?: string | null, gender?: Gender | null, address_ward?: string | null } | null> | null, next_token?: { __typename?: 'IdMetaNextToken', id?: string | null, meta?: string | null } | null } | null };

export type QueryCustomerHistoryQueryVariables = Exact<{
  key: CustomerIdMetaKeyInput;
}>;


export type QueryCustomerHistoryQuery = { __typename?: 'Query', queryCustomerHistory?: Array<{ __typename?: 'CustomerHistory', id?: string | null, meta?: string | null, customer_id?: string | null, created_at?: number | null, updated_at?: number | null, memo?: string | null, history_date?: string | null } | null> | null };

export type PutCustomerMutationVariables = Exact<{
  key?: InputMaybe<KeyInput>;
  input: CustomerInput;
}>;


export type PutCustomerMutation = { __typename?: 'Mutation', putCustomer: { __typename?: 'Customer', id?: string | null, meta?: string | null, created_at?: number | null, updated_at?: number | null, inquiry_date?: string | null, inquiry_address_ward?: string | null, inquiry_property_name?: string | null, residents?: number | null, nationality?: string | null, have_permanent_residency?: boolean | null, acquisition_expected_date?: string | null, year_of_construction?: string | null, inquiry_property_price?: number | null, inquiry_property_width?: number | null, inquiry_property_floor_plan?: FloorPlan | null, media?: string | null, line_resistration?: boolean | null, memo?: string | null, reaction?: InquiryReaction | null, appointment_status?: AppointmentStatus | null, address_ward?: string | null, address_other?: string | null, nearest_station?: string | null, on_foot_minutes?: number | null, plan_to_get_married?: boolean | null, is_get_married?: boolean | null, pet_breeding?: boolean | null, have_vehicle?: boolean | null, have_bicycle?: boolean | null, parking_fee?: number | null, total_customer_assets?: number | null, customer_asset?: number | null, parent_asset?: number | null, stocks_and_bonds?: number | null, other_asset?: number | null, debt?: number | null, details?: string | null, insurance?: Insurance | null, have_disease?: boolean | null, residence_type?: ResidenceType | null, residence_type_other?: string | null, residence_appearance?: ResidenceAppearance | null, have_ev?: boolean | null, residence_width?: number | null, residence_floor_plan?: FloorPlan | null, residence_rent?: number | null, have_residence_rent_subsidy?: boolean | null, residence_rent_subsidy?: number | null, residence_years?: number | null, residence_update_date?: string | null, purchase_motive?: string | null, when_looking_for?: string | null, model_experience?: number | null, inquiries_to_other?: boolean | null, width_of_desire?: number | null, width_of_min_desire?: number | null, desired_floor_plan?: FloorPlan | null, monthly_payment?: number | null, bonus_payment?: number | null, budget_max?: number | null, internet_search_conditions?: string | null, desired_area_and_station?: string | null, customer_info?: { __typename?: 'Parent', family_name?: string | null, name?: string | null, family_name_kana?: string | null, name_kana?: string | null, gender?: Gender | null, birth_date?: string | null, phone_number?: string | null, email?: string | null, annual_income?: number | null, length_of_service?: number | null, work_style?: WorkStyle | null, workplace?: string | null, industry_type?: string | null, nearest_station?: string | null, birthplace?: string | null } | null, consort_info?: { __typename?: 'Parent', family_name?: string | null, name?: string | null, family_name_kana?: string | null, name_kana?: string | null, gender?: Gender | null, birth_date?: string | null, phone_number?: string | null, email?: string | null, annual_income?: number | null, length_of_service?: number | null, work_style?: WorkStyle | null, workplace?: string | null, industry_type?: string | null, nearest_station?: string | null, birthplace?: string | null } | null, children_info?: Array<{ __typename?: 'Child', birth_date?: string | null, gender?: Gender | null, school_name?: string | null, school_area?: string | null } | null> | null, family_member_info?: Array<{ __typename?: 'FamilyMember', relationship?: string | null, birth_date?: string | null } | null> | null, compromise_point?: { __typename?: 'CompromisePointStates', sunny?: boolean | null, view?: boolean | null, one_floor?: boolean | null, north?: boolean | null, highway?: boolean | null, dirty?: boolean | null, accident?: boolean | null } | null } };

export type UpdateCustomerMutationVariables = Exact<{
  key: KeyInput;
  input: CustomerInput;
  type: CustomerInputType;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', id?: string | null, meta?: string | null, created_at?: number | null, updated_at?: number | null, inquiry_date?: string | null, inquiry_address_ward?: string | null, inquiry_property_name?: string | null, residents?: number | null, nationality?: string | null, have_permanent_residency?: boolean | null, acquisition_expected_date?: string | null, year_of_construction?: string | null, inquiry_property_price?: number | null, inquiry_property_width?: number | null, inquiry_property_floor_plan?: FloorPlan | null, media?: string | null, line_resistration?: boolean | null, memo?: string | null, reaction?: InquiryReaction | null, appointment_status?: AppointmentStatus | null, address_ward?: string | null, address_other?: string | null, nearest_station?: string | null, on_foot_minutes?: number | null, plan_to_get_married?: boolean | null, is_get_married?: boolean | null, pet_breeding?: boolean | null, have_vehicle?: boolean | null, have_bicycle?: boolean | null, parking_fee?: number | null, total_customer_assets?: number | null, customer_asset?: number | null, parent_asset?: number | null, stocks_and_bonds?: number | null, other_asset?: number | null, debt?: number | null, details?: string | null, insurance?: Insurance | null, have_disease?: boolean | null, residence_type?: ResidenceType | null, residence_type_other?: string | null, residence_appearance?: ResidenceAppearance | null, have_ev?: boolean | null, residence_width?: number | null, residence_floor_plan?: FloorPlan | null, residence_rent?: number | null, have_residence_rent_subsidy?: boolean | null, residence_rent_subsidy?: number | null, residence_years?: number | null, residence_update_date?: string | null, purchase_motive?: string | null, when_looking_for?: string | null, model_experience?: number | null, inquiries_to_other?: boolean | null, width_of_desire?: number | null, width_of_min_desire?: number | null, desired_floor_plan?: FloorPlan | null, monthly_payment?: number | null, bonus_payment?: number | null, budget_max?: number | null, internet_search_conditions?: string | null, desired_area_and_station?: string | null, customer_info?: { __typename?: 'Parent', family_name?: string | null, name?: string | null, family_name_kana?: string | null, name_kana?: string | null, gender?: Gender | null, birth_date?: string | null, phone_number?: string | null, email?: string | null, annual_income?: number | null, length_of_service?: number | null, work_style?: WorkStyle | null, workplace?: string | null, industry_type?: string | null, nearest_station?: string | null, birthplace?: string | null } | null, consort_info?: { __typename?: 'Parent', family_name?: string | null, name?: string | null, family_name_kana?: string | null, name_kana?: string | null, gender?: Gender | null, birth_date?: string | null, phone_number?: string | null, email?: string | null, annual_income?: number | null, length_of_service?: number | null, work_style?: WorkStyle | null, workplace?: string | null, industry_type?: string | null, nearest_station?: string | null, birthplace?: string | null } | null, children_info?: Array<{ __typename?: 'Child', birth_date?: string | null, gender?: Gender | null, school_name?: string | null, school_area?: string | null } | null> | null, family_member_info?: Array<{ __typename?: 'FamilyMember', relationship?: string | null, birth_date?: string | null } | null> | null, compromise_point?: { __typename?: 'CompromisePointStates', sunny?: boolean | null, view?: boolean | null, one_floor?: boolean | null, north?: boolean | null, highway?: boolean | null, dirty?: boolean | null, accident?: boolean | null } | null } };

export type DeleteCustomerMutationVariables = Exact<{
  key: KeyInput;
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', deleteCustomer: { __typename?: 'Customer', id?: string | null, meta?: string | null, created_at?: number | null, updated_at?: number | null, inquiry_date?: string | null, inquiry_address_ward?: string | null, inquiry_property_name?: string | null, residents?: number | null, nationality?: string | null, have_permanent_residency?: boolean | null, acquisition_expected_date?: string | null, year_of_construction?: string | null, inquiry_property_price?: number | null, inquiry_property_width?: number | null, inquiry_property_floor_plan?: FloorPlan | null, media?: string | null, line_resistration?: boolean | null, memo?: string | null, reaction?: InquiryReaction | null, appointment_status?: AppointmentStatus | null, address_ward?: string | null, address_other?: string | null, nearest_station?: string | null, on_foot_minutes?: number | null, plan_to_get_married?: boolean | null, is_get_married?: boolean | null, pet_breeding?: boolean | null, have_vehicle?: boolean | null, have_bicycle?: boolean | null, parking_fee?: number | null, total_customer_assets?: number | null, customer_asset?: number | null, parent_asset?: number | null, stocks_and_bonds?: number | null, other_asset?: number | null, debt?: number | null, details?: string | null, insurance?: Insurance | null, have_disease?: boolean | null, residence_type?: ResidenceType | null, residence_type_other?: string | null, residence_appearance?: ResidenceAppearance | null, have_ev?: boolean | null, residence_width?: number | null, residence_floor_plan?: FloorPlan | null, residence_rent?: number | null, have_residence_rent_subsidy?: boolean | null, residence_rent_subsidy?: number | null, residence_years?: number | null, residence_update_date?: string | null, purchase_motive?: string | null, when_looking_for?: string | null, model_experience?: number | null, inquiries_to_other?: boolean | null, width_of_desire?: number | null, width_of_min_desire?: number | null, desired_floor_plan?: FloorPlan | null, monthly_payment?: number | null, bonus_payment?: number | null, budget_max?: number | null, internet_search_conditions?: string | null, desired_area_and_station?: string | null, customer_info?: { __typename?: 'Parent', family_name?: string | null, name?: string | null, family_name_kana?: string | null, name_kana?: string | null, gender?: Gender | null, birth_date?: string | null, phone_number?: string | null, email?: string | null, annual_income?: number | null, length_of_service?: number | null, work_style?: WorkStyle | null, workplace?: string | null, industry_type?: string | null, nearest_station?: string | null, birthplace?: string | null } | null, consort_info?: { __typename?: 'Parent', family_name?: string | null, name?: string | null, family_name_kana?: string | null, name_kana?: string | null, gender?: Gender | null, birth_date?: string | null, phone_number?: string | null, email?: string | null, annual_income?: number | null, length_of_service?: number | null, work_style?: WorkStyle | null, workplace?: string | null, industry_type?: string | null, nearest_station?: string | null, birthplace?: string | null } | null, children_info?: Array<{ __typename?: 'Child', birth_date?: string | null, gender?: Gender | null, school_name?: string | null, school_area?: string | null } | null> | null, family_member_info?: Array<{ __typename?: 'FamilyMember', relationship?: string | null, birth_date?: string | null } | null> | null, compromise_point?: { __typename?: 'CompromisePointStates', sunny?: boolean | null, view?: boolean | null, one_floor?: boolean | null, north?: boolean | null, highway?: boolean | null, dirty?: boolean | null, accident?: boolean | null } | null } };

export type PutAppointmentMutationVariables = Exact<{
  key?: InputMaybe<KeyInput>;
  input: AppointmentInput;
}>;


export type PutAppointmentMutation = { __typename?: 'Mutation', putAppointment: { __typename?: 'Appointment', id?: string | null, meta?: string | null, customer_id?: string | null, created_at?: number | null, updated_at?: number | null, appointment_status?: AppointmentStatus | null, appointment_date?: string | null, rank?: AppointmentRank | null, appointment_family_number?: string | null, inquiry_price?: number | null, floor_plan?: FloorPlan | null, monthly_repayment_amount?: string | null, annual_income?: number | null, own_resources?: string | null, appointment_count?: number | null, media?: string | null, negotiation_person?: string | null, memo?: string | null, remarks?: string | null, neck?: string | null, preparation?: AppointPreparation | null, preparation_check?: boolean | null, appointment_result?: AppointmentResult | null, appointment_result_reason?: string | null, family_name?: string | null, name?: string | null, family_name_kana?: string | null, name_kana?: string | null, line_resistration?: boolean | null, birth_date?: string | null, gender?: Gender | null, address_ward?: string | null } };

export type DeleteAppointmentMutationVariables = Exact<{
  key: KeyInput;
}>;


export type DeleteAppointmentMutation = { __typename?: 'Mutation', deleteAppointment: { __typename?: 'Appointment', id?: string | null, meta?: string | null, customer_id?: string | null, created_at?: number | null, updated_at?: number | null, appointment_status?: AppointmentStatus | null, appointment_date?: string | null, rank?: AppointmentRank | null, appointment_family_number?: string | null, inquiry_price?: number | null, floor_plan?: FloorPlan | null, monthly_repayment_amount?: string | null, annual_income?: number | null, own_resources?: string | null, appointment_count?: number | null, media?: string | null, negotiation_person?: string | null, memo?: string | null, remarks?: string | null, neck?: string | null, preparation?: AppointPreparation | null, preparation_check?: boolean | null, appointment_result?: AppointmentResult | null, appointment_result_reason?: string | null, family_name?: string | null, name?: string | null, family_name_kana?: string | null, name_kana?: string | null, line_resistration?: boolean | null, birth_date?: string | null, gender?: Gender | null, address_ward?: string | null } };

export type CreateCustomerHistoryMutationVariables = Exact<{
  input: CustomerHistoryInput;
}>;


export type CreateCustomerHistoryMutation = { __typename?: 'Mutation', createCustomerHistory: { __typename?: 'CustomerHistory', id?: string | null, meta?: string | null, customer_id?: string | null, created_at?: number | null, updated_at?: number | null, memo?: string | null, history_date?: string | null } };

export type UpdateCustomerHistoryMutationVariables = Exact<{
  key?: InputMaybe<KeyInput>;
  input: CustomerHistoryInput;
}>;


export type UpdateCustomerHistoryMutation = { __typename?: 'Mutation', updateCustomerHistory: { __typename?: 'CustomerHistory', id?: string | null, meta?: string | null, customer_id?: string | null, created_at?: number | null, updated_at?: number | null, memo?: string | null, history_date?: string | null } };

export type DeleteCustomerHistoryMutationVariables = Exact<{
  key: KeyInput;
}>;


export type DeleteCustomerHistoryMutation = { __typename?: 'Mutation', deleteCustomerHistory: { __typename?: 'CustomerHistory', id?: string | null, meta?: string | null, customer_id?: string | null, created_at?: number | null, updated_at?: number | null, memo?: string | null, history_date?: string | null } };


export const GetCustomerDocument = gql`
    query GetCustomer($key: KeyInput!) {
  getCustomer(key: $key) {
    id
    meta
    created_at
    updated_at
    inquiry_date
    inquiry_address_ward
    inquiry_property_name
    residents
    nationality
    have_permanent_residency
    acquisition_expected_date
    year_of_construction
    inquiry_property_price
    inquiry_property_width
    inquiry_property_floor_plan
    media
    line_resistration
    memo
    reaction
    appointment_status
    address_ward
    address_other
    nearest_station
    on_foot_minutes
    plan_to_get_married
    is_get_married
    pet_breeding
    have_vehicle
    have_bicycle
    parking_fee
    customer_info {
      family_name
      name
      family_name_kana
      name_kana
      gender
      birth_date
      phone_number
      email
      annual_income
      length_of_service
      work_style
      workplace
      industry_type
      nearest_station
      birthplace
    }
    consort_info {
      family_name
      name
      family_name_kana
      name_kana
      gender
      birth_date
      phone_number
      email
      annual_income
      length_of_service
      work_style
      workplace
      industry_type
      nearest_station
      birthplace
    }
    children_info {
      birth_date
      gender
      school_name
      school_area
    }
    family_member_info {
      relationship
      birth_date
    }
    total_customer_assets
    customer_asset
    parent_asset
    stocks_and_bonds
    other_asset
    debt
    details
    insurance
    have_disease
    residence_type
    residence_type_other
    residence_appearance
    have_ev
    residence_width
    residence_floor_plan
    residence_rent
    have_residence_rent_subsidy
    residence_rent_subsidy
    residence_years
    residence_update_date
    purchase_motive
    when_looking_for
    model_experience
    inquiries_to_other
    width_of_desire
    width_of_min_desire
    desired_floor_plan
    monthly_payment
    bonus_payment
    budget_max
    internet_search_conditions
    desired_area_and_station
    compromise_point {
      sunny
      view
      one_floor
      north
      highway
      dirty
      accident
    }
  }
}
    `;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
      }
export function useGetCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const SearchCustomerDocument = gql`
    query SearchCustomer($conditions: SearchDurationConditionsInput, $options: SearchOptionsInput) {
  searchCustomer(conditions: $conditions, options: $options) {
    customers {
      id
      meta
      created_at
      updated_at
      inquiry_date
      inquiry_address_ward
      inquiry_property_name
      residents
      nationality
      have_permanent_residency
      acquisition_expected_date
      year_of_construction
      inquiry_property_price
      inquiry_property_width
      inquiry_property_floor_plan
      media
      line_resistration
      memo
      reaction
      appointment_status
      address_ward
      address_other
      nearest_station
      on_foot_minutes
      plan_to_get_married
      is_get_married
      pet_breeding
      have_vehicle
      have_bicycle
      parking_fee
      customer_info {
        family_name
        name
        family_name_kana
        name_kana
        gender
        birth_date
        phone_number
        email
        annual_income
        length_of_service
        work_style
        workplace
        industry_type
        nearest_station
        birthplace
      }
      consort_info {
        family_name
        name
        family_name_kana
        name_kana
        gender
        birth_date
        phone_number
        email
        annual_income
        length_of_service
        work_style
        workplace
        industry_type
        nearest_station
        birthplace
      }
      children_info {
        birth_date
        gender
        school_name
        school_area
      }
      family_member_info {
        relationship
        birth_date
      }
      total_customer_assets
      customer_asset
      parent_asset
      stocks_and_bonds
      other_asset
      debt
      details
      insurance
      have_disease
      residence_type
      residence_type_other
      residence_appearance
      have_ev
      residence_width
      residence_floor_plan
      residence_rent
      have_residence_rent_subsidy
      residence_rent_subsidy
      residence_years
      residence_update_date
      purchase_motive
      when_looking_for
      model_experience
      inquiries_to_other
      width_of_desire
      width_of_min_desire
      desired_floor_plan
      monthly_payment
      bonus_payment
      budget_max
      internet_search_conditions
      desired_area_and_station
    }
    next_token {
      id
      meta
    }
  }
}
    `;

/**
 * __useSearchCustomerQuery__
 *
 * To run a query within a React component, call `useSearchCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomerQuery({
 *   variables: {
 *      conditions: // value for 'conditions'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSearchCustomerQuery(baseOptions?: Apollo.QueryHookOptions<SearchCustomerQuery, SearchCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomerQuery, SearchCustomerQueryVariables>(SearchCustomerDocument, options);
      }
export function useSearchCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomerQuery, SearchCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomerQuery, SearchCustomerQueryVariables>(SearchCustomerDocument, options);
        }
export type SearchCustomerQueryHookResult = ReturnType<typeof useSearchCustomerQuery>;
export type SearchCustomerLazyQueryHookResult = ReturnType<typeof useSearchCustomerLazyQuery>;
export type SearchCustomerQueryResult = Apollo.QueryResult<SearchCustomerQuery, SearchCustomerQueryVariables>;
export const SearchAppointmentDocument = gql`
    query SearchAppointment($conditions: SearchDurationCustomerIdConditionsInput, $options: SearchOptionsInput) {
  searchAppointment(conditions: $conditions, options: $options) {
    appointments {
      id
      meta
      customer_id
      created_at
      updated_at
      appointment_status
      appointment_date
      rank
      appointment_family_number
      inquiry_price
      floor_plan
      monthly_repayment_amount
      annual_income
      own_resources
      appointment_count
      media
      negotiation_person
      memo
      remarks
      neck
      preparation
      preparation_check
      appointment_result
      appointment_result_reason
      family_name
      name
      family_name_kana
      name_kana
      line_resistration
      birth_date
      gender
      address_ward
    }
    next_token {
      id
      meta
    }
  }
}
    `;

/**
 * __useSearchAppointmentQuery__
 *
 * To run a query within a React component, call `useSearchAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAppointmentQuery({
 *   variables: {
 *      conditions: // value for 'conditions'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSearchAppointmentQuery(baseOptions?: Apollo.QueryHookOptions<SearchAppointmentQuery, SearchAppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAppointmentQuery, SearchAppointmentQueryVariables>(SearchAppointmentDocument, options);
      }
export function useSearchAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAppointmentQuery, SearchAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAppointmentQuery, SearchAppointmentQueryVariables>(SearchAppointmentDocument, options);
        }
export type SearchAppointmentQueryHookResult = ReturnType<typeof useSearchAppointmentQuery>;
export type SearchAppointmentLazyQueryHookResult = ReturnType<typeof useSearchAppointmentLazyQuery>;
export type SearchAppointmentQueryResult = Apollo.QueryResult<SearchAppointmentQuery, SearchAppointmentQueryVariables>;
export const QueryCustomerHistoryDocument = gql`
    query QueryCustomerHistory($key: CustomerIdMetaKeyInput!) {
  queryCustomerHistory(key: $key) {
    id
    meta
    customer_id
    created_at
    updated_at
    memo
    history_date
  }
}
    `;

/**
 * __useQueryCustomerHistoryQuery__
 *
 * To run a query within a React component, call `useQueryCustomerHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryCustomerHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryCustomerHistoryQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useQueryCustomerHistoryQuery(baseOptions: Apollo.QueryHookOptions<QueryCustomerHistoryQuery, QueryCustomerHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryCustomerHistoryQuery, QueryCustomerHistoryQueryVariables>(QueryCustomerHistoryDocument, options);
      }
export function useQueryCustomerHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryCustomerHistoryQuery, QueryCustomerHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryCustomerHistoryQuery, QueryCustomerHistoryQueryVariables>(QueryCustomerHistoryDocument, options);
        }
export type QueryCustomerHistoryQueryHookResult = ReturnType<typeof useQueryCustomerHistoryQuery>;
export type QueryCustomerHistoryLazyQueryHookResult = ReturnType<typeof useQueryCustomerHistoryLazyQuery>;
export type QueryCustomerHistoryQueryResult = Apollo.QueryResult<QueryCustomerHistoryQuery, QueryCustomerHistoryQueryVariables>;
export const PutCustomerDocument = gql`
    mutation PutCustomer($key: KeyInput, $input: CustomerInput!) {
  putCustomer(key: $key, input: $input) {
    id
    meta
    created_at
    updated_at
    inquiry_date
    inquiry_address_ward
    inquiry_property_name
    residents
    nationality
    have_permanent_residency
    acquisition_expected_date
    year_of_construction
    inquiry_property_price
    inquiry_property_width
    inquiry_property_floor_plan
    media
    line_resistration
    memo
    reaction
    appointment_status
    address_ward
    address_other
    nearest_station
    on_foot_minutes
    plan_to_get_married
    is_get_married
    pet_breeding
    have_vehicle
    have_bicycle
    parking_fee
    customer_info {
      family_name
      name
      family_name_kana
      name_kana
      gender
      birth_date
      phone_number
      email
      annual_income
      length_of_service
      work_style
      workplace
      industry_type
      nearest_station
      birthplace
    }
    consort_info {
      family_name
      name
      family_name_kana
      name_kana
      gender
      birth_date
      phone_number
      email
      annual_income
      length_of_service
      work_style
      workplace
      industry_type
      nearest_station
      birthplace
    }
    children_info {
      birth_date
      gender
      school_name
      school_area
    }
    family_member_info {
      relationship
      birth_date
    }
    total_customer_assets
    customer_asset
    parent_asset
    stocks_and_bonds
    other_asset
    debt
    details
    insurance
    have_disease
    residence_type
    residence_type_other
    residence_appearance
    have_ev
    residence_width
    residence_floor_plan
    residence_rent
    have_residence_rent_subsidy
    residence_rent_subsidy
    residence_years
    residence_update_date
    purchase_motive
    when_looking_for
    model_experience
    inquiries_to_other
    width_of_desire
    width_of_min_desire
    desired_floor_plan
    monthly_payment
    bonus_payment
    budget_max
    internet_search_conditions
    desired_area_and_station
    compromise_point {
      sunny
      view
      one_floor
      north
      highway
      dirty
      accident
    }
  }
}
    `;
export type PutCustomerMutationFn = Apollo.MutationFunction<PutCustomerMutation, PutCustomerMutationVariables>;

/**
 * __usePutCustomerMutation__
 *
 * To run a mutation, you first call `usePutCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putCustomerMutation, { data, loading, error }] = usePutCustomerMutation({
 *   variables: {
 *      key: // value for 'key'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePutCustomerMutation(baseOptions?: Apollo.MutationHookOptions<PutCustomerMutation, PutCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PutCustomerMutation, PutCustomerMutationVariables>(PutCustomerDocument, options);
      }
export type PutCustomerMutationHookResult = ReturnType<typeof usePutCustomerMutation>;
export type PutCustomerMutationResult = Apollo.MutationResult<PutCustomerMutation>;
export type PutCustomerMutationOptions = Apollo.BaseMutationOptions<PutCustomerMutation, PutCustomerMutationVariables>;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($key: KeyInput!, $input: CustomerInput!, $type: CustomerInputType!) {
  updateCustomer(key: $key, input: $input, type: $type) {
    id
    meta
    created_at
    updated_at
    inquiry_date
    inquiry_address_ward
    inquiry_property_name
    residents
    nationality
    have_permanent_residency
    acquisition_expected_date
    year_of_construction
    inquiry_property_price
    inquiry_property_width
    inquiry_property_floor_plan
    media
    line_resistration
    memo
    reaction
    appointment_status
    address_ward
    address_other
    nearest_station
    on_foot_minutes
    plan_to_get_married
    is_get_married
    pet_breeding
    have_vehicle
    have_bicycle
    parking_fee
    customer_info {
      family_name
      name
      family_name_kana
      name_kana
      gender
      birth_date
      phone_number
      email
      annual_income
      length_of_service
      work_style
      workplace
      industry_type
      nearest_station
      birthplace
    }
    consort_info {
      family_name
      name
      family_name_kana
      name_kana
      gender
      birth_date
      phone_number
      email
      annual_income
      length_of_service
      work_style
      workplace
      industry_type
      nearest_station
      birthplace
    }
    children_info {
      birth_date
      gender
      school_name
      school_area
    }
    family_member_info {
      relationship
      birth_date
    }
    total_customer_assets
    customer_asset
    parent_asset
    stocks_and_bonds
    other_asset
    debt
    details
    insurance
    have_disease
    residence_type
    residence_type_other
    residence_appearance
    have_ev
    residence_width
    residence_floor_plan
    residence_rent
    have_residence_rent_subsidy
    residence_rent_subsidy
    residence_years
    residence_update_date
    purchase_motive
    when_looking_for
    model_experience
    inquiries_to_other
    width_of_desire
    width_of_min_desire
    desired_floor_plan
    monthly_payment
    bonus_payment
    budget_max
    internet_search_conditions
    desired_area_and_station
    compromise_point {
      sunny
      view
      one_floor
      north
      highway
      dirty
      accident
    }
  }
}
    `;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      key: // value for 'key'
 *      input: // value for 'input'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const DeleteCustomerDocument = gql`
    mutation DeleteCustomer($key: KeyInput!) {
  deleteCustomer(key: $key) {
    id
    meta
    created_at
    updated_at
    inquiry_date
    inquiry_address_ward
    inquiry_property_name
    residents
    nationality
    have_permanent_residency
    acquisition_expected_date
    year_of_construction
    inquiry_property_price
    inquiry_property_width
    inquiry_property_floor_plan
    media
    line_resistration
    memo
    reaction
    appointment_status
    address_ward
    address_other
    nearest_station
    on_foot_minutes
    plan_to_get_married
    is_get_married
    pet_breeding
    have_vehicle
    have_bicycle
    parking_fee
    customer_info {
      family_name
      name
      family_name_kana
      name_kana
      gender
      birth_date
      phone_number
      email
      annual_income
      length_of_service
      work_style
      workplace
      industry_type
      nearest_station
      birthplace
    }
    consort_info {
      family_name
      name
      family_name_kana
      name_kana
      gender
      birth_date
      phone_number
      email
      annual_income
      length_of_service
      work_style
      workplace
      industry_type
      nearest_station
      birthplace
    }
    children_info {
      birth_date
      gender
      school_name
      school_area
    }
    family_member_info {
      relationship
      birth_date
    }
    total_customer_assets
    customer_asset
    parent_asset
    stocks_and_bonds
    other_asset
    debt
    details
    insurance
    have_disease
    residence_type
    residence_type_other
    residence_appearance
    have_ev
    residence_width
    residence_floor_plan
    residence_rent
    have_residence_rent_subsidy
    residence_rent_subsidy
    residence_years
    residence_update_date
    purchase_motive
    when_looking_for
    model_experience
    inquiries_to_other
    width_of_desire
    width_of_min_desire
    desired_floor_plan
    monthly_payment
    bonus_payment
    budget_max
    internet_search_conditions
    desired_area_and_station
    compromise_point {
      sunny
      view
      one_floor
      north
      highway
      dirty
      accident
    }
  }
}
    `;
export type DeleteCustomerMutationFn = Apollo.MutationFunction<DeleteCustomerMutation, DeleteCustomerMutationVariables>;

/**
 * __useDeleteCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerMutation, { data, loading, error }] = useDeleteCustomerMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerMutation, DeleteCustomerMutationVariables>(DeleteCustomerDocument, options);
      }
export type DeleteCustomerMutationHookResult = ReturnType<typeof useDeleteCustomerMutation>;
export type DeleteCustomerMutationResult = Apollo.MutationResult<DeleteCustomerMutation>;
export type DeleteCustomerMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const PutAppointmentDocument = gql`
    mutation PutAppointment($key: KeyInput, $input: AppointmentInput!) {
  putAppointment(key: $key, input: $input) {
    id
    meta
    customer_id
    created_at
    updated_at
    appointment_status
    appointment_date
    rank
    appointment_family_number
    inquiry_price
    floor_plan
    monthly_repayment_amount
    annual_income
    own_resources
    appointment_count
    media
    negotiation_person
    memo
    remarks
    neck
    preparation
    preparation_check
    appointment_result
    appointment_result_reason
    family_name
    name
    family_name_kana
    name_kana
    line_resistration
    birth_date
    gender
    address_ward
  }
}
    `;
export type PutAppointmentMutationFn = Apollo.MutationFunction<PutAppointmentMutation, PutAppointmentMutationVariables>;

/**
 * __usePutAppointmentMutation__
 *
 * To run a mutation, you first call `usePutAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putAppointmentMutation, { data, loading, error }] = usePutAppointmentMutation({
 *   variables: {
 *      key: // value for 'key'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePutAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<PutAppointmentMutation, PutAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PutAppointmentMutation, PutAppointmentMutationVariables>(PutAppointmentDocument, options);
      }
export type PutAppointmentMutationHookResult = ReturnType<typeof usePutAppointmentMutation>;
export type PutAppointmentMutationResult = Apollo.MutationResult<PutAppointmentMutation>;
export type PutAppointmentMutationOptions = Apollo.BaseMutationOptions<PutAppointmentMutation, PutAppointmentMutationVariables>;
export const DeleteAppointmentDocument = gql`
    mutation DeleteAppointment($key: KeyInput!) {
  deleteAppointment(key: $key) {
    id
    meta
    customer_id
    created_at
    updated_at
    appointment_status
    appointment_date
    rank
    appointment_family_number
    inquiry_price
    floor_plan
    monthly_repayment_amount
    annual_income
    own_resources
    appointment_count
    media
    negotiation_person
    memo
    remarks
    neck
    preparation
    preparation_check
    appointment_result
    appointment_result_reason
    family_name
    name
    family_name_kana
    name_kana
    line_resistration
    birth_date
    gender
    address_ward
  }
}
    `;
export type DeleteAppointmentMutationFn = Apollo.MutationFunction<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>;

/**
 * __useDeleteAppointmentMutation__
 *
 * To run a mutation, you first call `useDeleteAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAppointmentMutation, { data, loading, error }] = useDeleteAppointmentMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>(DeleteAppointmentDocument, options);
      }
export type DeleteAppointmentMutationHookResult = ReturnType<typeof useDeleteAppointmentMutation>;
export type DeleteAppointmentMutationResult = Apollo.MutationResult<DeleteAppointmentMutation>;
export type DeleteAppointmentMutationOptions = Apollo.BaseMutationOptions<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>;
export const CreateCustomerHistoryDocument = gql`
    mutation CreateCustomerHistory($input: CustomerHistoryInput!) {
  createCustomerHistory(input: $input) {
    id
    meta
    customer_id
    created_at
    updated_at
    memo
    history_date
  }
}
    `;
export type CreateCustomerHistoryMutationFn = Apollo.MutationFunction<CreateCustomerHistoryMutation, CreateCustomerHistoryMutationVariables>;

/**
 * __useCreateCustomerHistoryMutation__
 *
 * To run a mutation, you first call `useCreateCustomerHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerHistoryMutation, { data, loading, error }] = useCreateCustomerHistoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerHistoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerHistoryMutation, CreateCustomerHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerHistoryMutation, CreateCustomerHistoryMutationVariables>(CreateCustomerHistoryDocument, options);
      }
export type CreateCustomerHistoryMutationHookResult = ReturnType<typeof useCreateCustomerHistoryMutation>;
export type CreateCustomerHistoryMutationResult = Apollo.MutationResult<CreateCustomerHistoryMutation>;
export type CreateCustomerHistoryMutationOptions = Apollo.BaseMutationOptions<CreateCustomerHistoryMutation, CreateCustomerHistoryMutationVariables>;
export const UpdateCustomerHistoryDocument = gql`
    mutation UpdateCustomerHistory($key: KeyInput, $input: CustomerHistoryInput!) {
  updateCustomerHistory(key: $key, input: $input) {
    id
    meta
    customer_id
    created_at
    updated_at
    memo
    history_date
  }
}
    `;
export type UpdateCustomerHistoryMutationFn = Apollo.MutationFunction<UpdateCustomerHistoryMutation, UpdateCustomerHistoryMutationVariables>;

/**
 * __useUpdateCustomerHistoryMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerHistoryMutation, { data, loading, error }] = useUpdateCustomerHistoryMutation({
 *   variables: {
 *      key: // value for 'key'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerHistoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerHistoryMutation, UpdateCustomerHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerHistoryMutation, UpdateCustomerHistoryMutationVariables>(UpdateCustomerHistoryDocument, options);
      }
export type UpdateCustomerHistoryMutationHookResult = ReturnType<typeof useUpdateCustomerHistoryMutation>;
export type UpdateCustomerHistoryMutationResult = Apollo.MutationResult<UpdateCustomerHistoryMutation>;
export type UpdateCustomerHistoryMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerHistoryMutation, UpdateCustomerHistoryMutationVariables>;
export const DeleteCustomerHistoryDocument = gql`
    mutation DeleteCustomerHistory($key: KeyInput!) {
  deleteCustomerHistory(key: $key) {
    id
    meta
    customer_id
    created_at
    updated_at
    memo
    history_date
  }
}
    `;
export type DeleteCustomerHistoryMutationFn = Apollo.MutationFunction<DeleteCustomerHistoryMutation, DeleteCustomerHistoryMutationVariables>;

/**
 * __useDeleteCustomerHistoryMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerHistoryMutation, { data, loading, error }] = useDeleteCustomerHistoryMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteCustomerHistoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerHistoryMutation, DeleteCustomerHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerHistoryMutation, DeleteCustomerHistoryMutationVariables>(DeleteCustomerHistoryDocument, options);
      }
export type DeleteCustomerHistoryMutationHookResult = ReturnType<typeof useDeleteCustomerHistoryMutation>;
export type DeleteCustomerHistoryMutationResult = Apollo.MutationResult<DeleteCustomerHistoryMutation>;
export type DeleteCustomerHistoryMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerHistoryMutation, DeleteCustomerHistoryMutationVariables>;